import { render } from "./Ranking.vue?vue&type=template&id=7645d387&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import "./Ranking.vue?vue&type=style&index=0&id=7645d387&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7645d387"]])

export default __exports__